module.exports = __webpack_public_path__ + "static/media/Brochure-Envelop.8b08480b.jpg";